import {bufferTime, catchError, distinct, filter, first, groupBy, map, mapTo, mergeMap, tap} from "rxjs/operators";
import {iif, of} from 'rxjs';
import {networkError} from "../actions/ui";
import {combineEpics, ofType} from "redux-observable";
import * as R from 'ramda';
import {getMeetingMinutes$, getMeetingMinutesMulti$} from "../services/projects";
import {
  catchErrorsandResume,
  INDIVIDUAL_ID_BUFFER_MS,
  INDIVIDUAL_ID_FETCH_SIZE,
  MODEL_INSERTION_BUFFER_INTERVAL_MS,
  requestDedupInterval$
} from "./index";
import {injectSubview, setSubview, setSubviewCache} from "../actions/view";
import {
  API_GET_MEETING_MINUTES,
  API_GET_MEETING_MINUTES_DONE,
  API_GET_MEETING_MINUTES_MULTIPLE,
  API_GET_MEETING_MINUTES_MULTIPLE_DONE, getMeetingMinutesDone, getMeetingMinutesMultiple, getMeetingMinutesMultipleDone
} from "../actions/meetingMinutes";

const SVCLF = setSubviewCache({ loading: false });

const beginLoading = action$ => action$.pipe(
  ofType(API_GET_MEETING_MINUTES),
  bufferTime(INDIVIDUAL_ID_BUFFER_MS, null, INDIVIDUAL_ID_FETCH_SIZE),
  filter(actions => actions.length > 0),
  first(),
  mapTo(setSubviewCache({ loading: true })),
  catchErrorsandResume(20025)
);

const endLoading = action$ => action$.pipe(
  ofType(API_GET_MEETING_MINUTES_DONE, API_GET_MEETING_MINUTES_MULTIPLE_DONE),
  bufferTime(INDIVIDUAL_ID_BUFFER_MS, null, INDIVIDUAL_ID_FETCH_SIZE),
  filter(actions => actions.length > 0),
  first(),
  mapTo(setSubviewCache({ loading: false })),
  catchErrorsandResume(20026)
);

const getSingleEpic = action$ => action$.pipe(
  ofType(API_GET_MEETING_MINUTES),
  mergeMap(action => getMeetingMinutes$({ id: action.payload.id, projectId: action.payload.projectId }).pipe(
    map(({response}) => getMeetingMinutesDone(response)),
    catchError(error => of(SVCLF, networkError({...error, number: '10080-'+error.status})))
  )),
  catchErrorsandResume(20029)
);

const getSingleEpicMulti = action$ => action$.pipe(
  ofType(API_GET_MEETING_MINUTES),
  groupBy(action => action.payload.projectId),
  mergeMap(group$ => group$.pipe(
    distinct(action => action.payload.id, requestDedupInterval$),
    bufferTime(INDIVIDUAL_ID_BUFFER_MS, null, INDIVIDUAL_ID_FETCH_SIZE),
    filter(actions => actions.length > 0),
    mergeMap(actions => iif(() => actions.length > 1,
      getMeetingMinutesMulti$({ projectId: actions[0].payload.projectId, ids: actions.map(action => action.payload.id) }).pipe(
        filter(({ response }) => response && response['results']),
        map(({ response }) => setSubview(response.results)),
        catchError(error => of(SVCLF, networkError({...error, number: '10081-'+error.status})))
      ),
      getMeetingMinutes$({ id: actions[0].payload.id, projectId: actions[0].payload.projectId }).pipe(
        map(({ response }) => getMeetingMinutesDone(response)),
        catchError(error => of(SVCLF, networkError({...error, number: '10082-'+error.status})))
      )
    )),
    catchError(error => of(SVCLF, networkError({...error, number: '10083-'+error.status})))
  )),
  catchErrorsandResume(20030)
);

const processSingleEpic = action$ => action$.pipe(
  ofType(API_GET_MEETING_MINUTES_DONE),
  map(action => action.payload),
  bufferTime(MODEL_INSERTION_BUFFER_INTERVAL_MS),
  filter(results => results.length > 0),
  tap(meetingminutes => meetingminutes[0].callback && meetingminutes[0].callback(meetingminutes[0].response.resource.id)),
  map(results => results.map(meetingminutes => meetingminutes.response)),
  map(results => setSubview(results)),
  catchErrorsandResume(20032)
);

const getMultipleEpic = action$ => action$.pipe(
  ofType(API_GET_MEETING_MINUTES_MULTIPLE),
  mergeMap(action => getMeetingMinutes$({ id: action.payload.id, projectId: action.payload.projectId, offset: action.payload.offset }).pipe(
    map(({response}) => getMeetingMinutesMultipleDone(response)),
    catchError(error => of(SVCLF, networkError({...error, number: '10084-'+error.status})))
  )),
  catchErrorsandResume(20028)
);

const processMultipleEpic = action$ => action$.pipe(
  ofType(API_GET_MEETING_MINUTES_MULTIPLE_DONE),
  filter(action => action.payload && action.payload.results),
  map(action => action.payload.results),
  bufferTime(MODEL_INSERTION_BUFFER_INTERVAL_MS),
  map(results => R.unnest(results)),
  filter(results => results.length > 0),
  map(results => injectSubview(results)),
  catchErrorsandResume(20031)
);

const getMoreEpic = action$ => action$.pipe(
  ofType(API_GET_MEETING_MINUTES_MULTIPLE_DONE),
  filter(action => action.payload && action.payload.results && action.payload.results.length === action.payload.limit),
  map(action => getMeetingMinutesMultiple(action.payload.results.slice(-1)[0].resource.projectid, action.payload.results.slice(-1)[0].resource.id)),
  catchErrorsandResume(20027)
);

export const meetingMinutesEpic = combineEpics(
  beginLoading,
  endLoading,
  // getSingleEpic,
  getSingleEpicMulti,
  processSingleEpic,
  getMultipleEpic,
  processMultipleEpic,
  getMoreEpic
);



// WEBPACK FOOTER //
// ./src/network/meetingMinutes.js